module.exports = __webpack_public_path__ + "static/media/chiken_icon.f9164807.png";